
import EditDynamicProfile from './EditDynamicProfile';
import ListDynamicProfiles from './ListDynamicProfiles';
import ViewDynamicProfile from './ViewDynamicProfile';
import CreateDynamicProfile from './CreateDynamicProfile';

export default { ListDynamicProfiles, ViewDynamicProfile, CreateDynamicProfile, EditDynamicProfile };



// WEBPACK FOOTER //
// ./src/components/pages/admin/dynamicProfiles/index.js